import { AttributeType } from "./attribute-type.enum";
import { LookupListItem } from "./lookup-list-item";
import { ResourceAttributeDefinitionDto } from "./resource-attribute-definition";

export class AttributeDefinition{
    public id: number;
  
    public name: string;
    public attributeTypeId: AttributeType;
    public isRequired: boolean;
    public isPrivate: boolean;
    public isPricingCatalog: boolean;
    public listOrder: number;
    public isInUse: boolean;
    public attributeLookupListId?: number;
    public attributeTemplateId: number;
    public value?: any;
    public removable: boolean;  
    public formControlName: string;

    public lookupItems?: LookupListItem[];
      
    constructor(dto: ResourceAttributeDefinitionDto, formControlName: string, defaultValue?: object){
        this.id = dto.id;
        this.isRequired = dto.isRequired;
        this.attributeTypeId = dto.attributeTypeId;
        this.listOrder = dto.listOrder;
        this.isInUse = dto.isInUse;
        this.name = dto.name;
        this.isPrivate = dto.isPrivate;
        this.isPricingCatalog = dto.isPricingCatalog;
        this.attributeTemplateId = dto.attributeTemplateId;
        this.attributeLookupListId = dto.attributeLookupListId;
        this.value = defaultValue;
        this.removable = !dto.isRequired;
        this.formControlName = formControlName;
    }    
}